import { Component, Input, OnInit, Output, ElementRef, ViewChild, EventEmitter } from '@angular/core';
import { BehaviorSubject, catchError, from, map, Observable, pipe } from 'rxjs';
import { Pipe, PipeTransform } from '@angular/core';
import { Category } from 'src/app/Models/category';
import { Policy } from 'src/app/Models/policy';
import { UserInfo } from 'src/app/Models/user-info';
import { CategoryService } from 'src/app/Services/category.service';
import { UserService } from 'src/app/Services/user.service';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { validateBasis } from '@angular/flex-layout';
import { PolicyForm } from 'src/app/Models/policy-form';
import { PolicyService } from 'src/app/Services/policy.service';
import { FileToUpload } from 'src/app/Models/file-to-upload';
import { FileService } from 'src/app/Services/file.service';
import { ProgressStatus, ProgressStatusEnum } from 'src/app/Interfaces/ProgressStatus';
import { HttpEventType } from '@angular/common/http';

// Maximum file size allowed to be uploaded = 1MB
const MAX_SIZE: number = 1048576;

@Component({
  selector: 'app-policy-management',
  templateUrl: './policy-management.component.html',
  styleUrls: ['./policy-management.component.css']
})

export class PolicyManagementComponent implements OnInit {
  currentUserInfo : UserInfo;
  userType: string;
  userName: string;
  categoryList_New : Category[];
  categoryList : any[];
  policyList : Policy[];
  policyList_filter : Policy[];
  selectedCategoryID : number;
  currentUserPNumber : string;
  newFile : any = null;
  progress: number;
  message: string;
  private apiCall = '/getcategorypolicylist/';
  @Output() public uploadStatus: EventEmitter<ProgressStatus>;
  @ViewChild('inputFile') inputFile: ElementRef;

  addPolicyForm = new FormGroup ({
    PNumber : new FormControl(),
    selectedCategoryID_New : new FormControl(0, Validators.required),
    title_New : new FormControl('', Validators.required),
    policyNumber_New : new FormControl('', Validators.required),
    policyNumberFormer_New : new FormControl(),
    file_New : new FormControl(null, [Validators.required])
  })

  updatePolicyListForm = new FormGroup ({
    selectedCategoryID : new FormControl(0, Validators.required),

  })

  //filename = new FormControl();
  policyID = new FormControl();

  displayedColumns = ["seqNo", "category", "title", "policyNumber", "policyNumberFormer", "fileName", "status", "action"];
  isDisabled:boolean = true;
  fileName_New = '';
  //file : File = null;
  messages: string[] = [];

  constructor(private policyService: PolicyService
    , private userService: UserService
    , private formBuilder: FormBuilder
    , private fileService : FileService) { 

      this.uploadStatus = new EventEmitter<ProgressStatus>();
    }

  ngOnInit(): void {
    this.currentUserInfo = this.userService.getCurrentUserInfo();
    if (this.currentUserInfo !== undefined && this.currentUserInfo !== null && Object.keys(this.currentUserInfo).length > 0) {
      this.userType = this.currentUserInfo.userType;
      this.userName = this.currentUserInfo.userName;
      this.currentUserPNumber = this.currentUserInfo.userPNumber;
      this.updatePolicyListForm.value.selectedCategoryID = 0;
      this.getCategoryPolicies("0");
      this.addPolicyForm.value.selectedCategoryID_New = 0;
      this.updatePolicyListForm.value.selectedCategoryID = 0;
    }
  }

  enableFileButton() {
    var fileButton = false;
    var selectedCategoryID = this.addPolicyForm.value.selectedCategoryID_New;
    var titleTxt = this.addPolicyForm.value.title_New;
    var policyNumberTxt = this.addPolicyForm.value.policyNumber_New;
    //var selectedCategoryID = (<HTMLInputElement>document.getElementById("selectedCategoryID")).value;
    //var selectedCategoryID = (<HTMLInputElement>document.getElementById("selectedCategoryID")).value;

    if (selectedCategoryID != 0 && titleTxt != "" && policyNumberTxt != "") {
      fileButton = true;
    }

    if (fileButton) {
      (<HTMLInputElement>document.getElementById("file_New")).disabled = false;
    }
    else {
      (<HTMLInputElement>document.getElementById("file_New")).disabled = true;
    }
  }

  onFileSelected(event) {
    if (event.target.files && event.target.files.length > 0) {
      if (event.target.files[0].size < MAX_SIZE) {
        this.addPolicyForm.value.file_New = event.target.files[0];
        this.newFile = event.target.files[0];
        this.readAndUploadFile(this.newFile);
        //this.addPolicy();
        //this.fileName_New = this.file_New.name;
        //file : File = event.target.fieles[0];
        //(<HTMLInputElement>document.getElementById("file_New")).disabled = false;
        //(<HTMLInputElement>document.getElementById("addPolicyBtn")).disabled = false;
      }
      else {
        // Display error message
        //(<HTMLInputElement>document.getElementById("file_New")).disabled = true;
        //(<HTMLInputElement>document.getElementById("addPolicyBtn")).disabled = true;
        this.messages.push("File: " + event.target.files[0].name + " is too large to upload.");
      }
  
    }
  }

  getCategoryPolicies(categoryID) {
    this.policyList = null;
    this.categoryList = null;
    this.policyList_filter = null;
    this.policyService.getPolicis(this.apiCall + this.currentUserInfo.userPNumber + categoryID).subscribe(
      data => {
        this.categoryList_New = data['categories'].filter(item => item.active == "Active");
        //this.categoryList = this.categoryList_New;
        this.policyList = data['policies'];
        this.categoryList = this.policyList.map(this.selectFewerProps);
        this.categoryList = this.categoryList.filter(function (a) {
          var key = a.categoryID + '|' + a.category;
          if (!this[key]) {
              this[key] = true;
              return true;
          }
        }, Object.create(null));

        if (categoryID !== "0") {
            this.policyList_filter = this.policyList.filter(item => item.categoryID == categoryID);
        }

        if (this.policyList_filter !== undefined && this.policyList_filter !== null) {
          this.policyList = this.policyList_filter;
        }
        // this.categoryList = this.policyList.map(data => ({
        //   categoryID : data.categoryID,
        //   category : data.category
        // }));
        //this.categoryList = data['policies'].filter(item => item.active == "Active");
        //this.updatePolicyListForm.value.selectedCategoryID = categoryID;
        this.selectedCategoryID = categoryID;
      }
    );
  }

  private selectFewerProps(show){
    const {categoryID, category} = show;
    return {categoryID, category};
  }

  addPolicy() {
    var content = new PolicyForm();

    content.UserPNumber = this.currentUserInfo.userPNumber;
    content.CategoryID = this.addPolicyForm.value.selectedCategoryID_New;
    content.Title = this.addPolicyForm.value.title_New;
    content.PolicyNumber = this.addPolicyForm.value.policyNumber_New;
    content.PolicyNumberFormer = this.addPolicyForm.value.policyNumberFormer_New;
    content.FileName = this.newFile.name; //this.addPolicyForm.value.file_New;
    console.log("addpolicy content: " + JSON.stringify(content));
    this.policyService.addPolicy('/sppolicyadd', content).subscribe(
      data => {
        //this.readAndUploadFile(this.newFile);
        this.categoryList_New = data['categories'];
        this.policyList = data['policies'];
        this.categoryList = this.policyList.map(this.selectFewerProps);
        // this.categoryList = this.policyList.filter((categoryID, pos, ary) => ary.indexOf(categoryID) === pos);
        this.categoryList = this.categoryList.filter(function (a) {
          var key = a.categoryID + '|' + a.category;
          if (!this[key]) {
              this[key] = true;
              return true;
          }
        }, Object.create(null));
        var resultMessages = data['PolicyAddResults'];
        this.messages.push("Policy added.");
        this.addPolicyForm.patchValue({
          file_New : null,
          policyNumber_New : '',
          policyNumberFormer_New : '',
          title_New : '',
        });

        // this.addPolicyForm.value.file_New = null;
        // this.addPolicyForm.value.policyNumberFormer_New = "";
        // this.addPolicyForm.value.policyNumber_New = "";
        // this.addPolicyForm.value.title_New = "";
        //this.messages.push(resultMessages[0]['Message']);
        //return data;
      }
    );
  }

  toggleText(pID, active) {
    //var cID = document.getElementById("categoryID");
    var newTitle = document.getElementById("title_" + pID);
    var newPolicyNumber = document.getElementById("policyNumber_" + pID);
    var newFileName = document.getElementById("FileName_" + pID);
    var newTitle = document.getElementById("title_" + pID);
    var changeButton = (<HTMLInputElement>document.getElementById("change_" + pID)).value;
    if (changeButton === 'Change') {
      (<HTMLInputElement>document.getElementById("title_" + pID)).disabled = false;
      (<HTMLInputElement>document.getElementById("policyNumber_" + pID)).disabled = false;
      (<HTMLInputElement>document.getElementById("policyNumberFormer_" + pID)).disabled = false;
      //(<HTMLInputElement>document.getElementById("fileName_" + pID)).disabled = false;
      (<HTMLInputElement>document.getElementById("status_" + pID)).value = active;
      (<HTMLInputElement>document.getElementById("status_" + pID)).style.visibility = 'visible';
      (<HTMLInputElement>document.getElementById("lableStatus_" + pID)).style.visibility = 'hidden';
      (<HTMLInputElement>document.getElementById("change_" + pID)).setAttribute('value', 'Cancel');
      (<HTMLInputElement>document.getElementById("update_" + pID)).disabled = false;
    }
    else if (changeButton === 'Cancel') {
      (<HTMLInputElement>document.getElementById("title_" + pID)).disabled = true;
      (<HTMLInputElement>document.getElementById("policyNumber_" + pID)).disabled = true;
      (<HTMLInputElement>document.getElementById("policyNumberFormer_" + pID)).disabled = true;
      //(<HTMLInputElement>document.getElementById("fileName_" + pID)).disabled = true;
      (<HTMLInputElement>document.getElementById("lableStatus_" + pID)).style.visibility = 'visible';
      (<HTMLInputElement>document.getElementById("status_" + pID)).style.visibility = 'hidden';
      (<HTMLInputElement>document.getElementById("change_" + pID)).setAttribute('value', 'Change');
      (<HTMLInputElement>document.getElementById("update_" + pID)).disabled = true;
    }
  }

  updatePolicy(pID) {
    var content = new PolicyForm();

    content.UserPNumber = this.currentUserInfo.userPNumber;
    content.PolicyID = pID;
    content.Title = (<HTMLInputElement>document.getElementById("title_" + pID)).value;
    content.PolicyNumber = (<HTMLInputElement>document.getElementById("policyNumber_" + pID)).value;
    content.FileName = (<HTMLInputElement>document.getElementById("fileName_" + pID)).value;
    content.Active = (<HTMLInputElement>document.getElementById("status_" + pID)).value;
    //content.Title = (<HTMLInputElement>document.getElementById("title_" + pID)).value;
    this.policyService.updatePolicy('/sppolicyupdate', content).subscribe(
      data => {
        //this.categoryList = data['categories'];
        this.policyList = data['policies'];
        //return data;
      }
    );
  }

  private readAndUploadFile(theFile: any) {
    let file = new FileToUpload();
    let today = Date;
    // Set File Information
    file.FileName = theFile.name;
    file.FileSize = theFile.size;
    file.FileType = theFile.type;
    file.LastModifiedTime = theFile.lastModified;
    file.LastModifiedDate = today.toString(); //theFile.lastModifiedDate;
    
    // Use FileReader() object to get file to upload
    // NOTE: FileReader only works with newer browsers
    let reader = new FileReader();
    
    // Setup onload event for reader
    reader.onload = () => {
        // Store base64 encoded representation of file
        file.FileAsBase64 = reader.result.toString();
        
        // POST to server
        this.fileService.FileUpload(file);
    }
    
    // Read the file
    reader.readAsDataURL(theFile);
  }

  public uploadFile(event) {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      this.uploadStatus.emit({status: ProgressStatusEnum.START});
      this.fileService.uploadFile(file).subscribe(
        data => {
          if (data) {
            switch (data.type) {
              case HttpEventType.UploadProgress:
                this.uploadStatus.emit( {status: ProgressStatusEnum.IN_PROGRESS, percentage: Math.round((data.loaded / data.total) * 100)});
                break;
              case HttpEventType.Response:
                this.inputFile.nativeElement.value = '';
                this.uploadStatus.emit( {status: ProgressStatusEnum.COMPLETE});
                break;
            }
          }
        },
        error => {
          this.inputFile.nativeElement.value = '';
          this.uploadStatus.emit({status: ProgressStatusEnum.ERROR});
        }
      );
    }
  }

  public upload(event) {
    console.log("upload is called: " + JSON.stringify(event));
    if (event.target.files && event.target.files.length > 0) {
      this.newFile = event.target.files[0];
      this.fileService.upload(this.newFile).subscribe(
        pipe(
          data => {
            console.log("uplad return data: " + JSON.stringify(data));
            // if (data === "Policy is added.") {
            //   this.addPolicy();
            //   this.messages.push("Policy is added.");
            // }
            // else {
            //   this.messages.push("Policy is not added.");
            // }
          }
        )
      );
      //this.addPolicy();
      this.messages.push("File uploaded.");
      this.addPolicyForm.value.file_New.text = "Change File";
    }
  }

  changeCategory(event) {
    var categoryID = "0";
    if (event.target.value !== "0") {
      var categoryIDAry = event.target.value.split(":");
      categoryID = categoryIDAry[1].replace(" ", "");
    }
    this.getCategoryPolicies(categoryID);
  }
}
